import { Button, ButtonGroup, Card, CardBody, CardHeader } from "reactstrap";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  title: string;
  entryLimit: number;
  setEntryLimit: (value: number | ((prevState: number) => number)) => void;
  limitOptions: number[];
}

export function LimitEntriesCard({
  title,
  entryLimit,
  setEntryLimit,
  limitOptions,
}: Props) {
  return (
    <Card>
      <CardHeader>
        <FontAwesomeIcon icon={faFileLines} /> {title}
      </CardHeader>
      <CardBody>
        <ButtonGroup>
          {limitOptions.map((limit) => (
            <Button
              key={limit}
              color="primary"
              outline
              onClick={() => setEntryLimit(limit)}
              active={entryLimit === limit}
            >
              {limit}
            </Button>
          ))}
        </ButtonGroup>
      </CardBody>
    </Card>
  );
}
